import type { ConceptDef } from '../types';

export const matchNumbers: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-numbers',
  label: 'Match Numbers',
  category: 'Matching',
  description: 'See a numeral; tap the identical numeral among tiles.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '1', answer: '1' },
      { say: '2', answer: '2' },
      { say: '3', answer: '3' },
      { say: '4', answer: '4' },
      { say: '5', answer: '5' },
      { say: '6', answer: '6' },
    ],
  },
};
